import { createAction, props } from '@ngrx/store';
import { TemplateFilter } from '@modules/template/student/models/template-filter';
import { ClassroomCourse, ClassroomCourseFilter } from '@modules/course/classroom/models';
import { Template } from '@modules/template/student/models/template';
import { CourseRequest } from "@modules/template/student/models/course-request";

export enum TemplateActions {
  FetchTemplates = '[Api/Template] Fetch Templates',
  FetchAllTemplates = '[Api/Template] Fetch All Templates',
  FetchTemplateSlotCount = '[Api/Template] Fetch Templates Slot Counts',
  FetchTemplate = '[Api/Template] Fetch Template',
  FetchClassroomCourse = '[Api/Classroom] Fetch Classroom Courses',
  AddTemplates = '[Template] Add Templates',
  AddTemplate = '[Template] Add Template',
  AddClassroomFilter = '[Template] Add Classroom Filter',
  ResetClassroomFilter = '[Template] Reset Classroom Filter',
  AddClassroomCourses = '[Template] Add Classroom Courses',
  RemoveClassroomCourses = '[Template] Remove Classroom Courses',
  RequestClassroomCourse = '[Template] Request Classroom Course',
  AddError = '[Template] Add Template Error',

}

export const FetchTemplates = createAction(TemplateActions.FetchTemplates, props<{ filter: TemplateFilter }>());
export const FetchTemplate = createAction(TemplateActions.FetchTemplate, props<{ id: string }>());
export const FetchClassroomCourses = createAction(
  TemplateActions.FetchClassroomCourse,
  props<{ templateId: string; filter?: ClassroomCourseFilter }>()
);
export const FetchAllTemplates = createAction(TemplateActions.FetchAllTemplates, props<{ filter: TemplateFilter }>());
export const FetchTemplatesSlotCount = createAction(TemplateActions.FetchTemplateSlotCount, props<{ templates: Template[] }>());

export const AddTemplates = createAction(TemplateActions.AddTemplates, props<{ templates: Template[] }>());
export const AddTemplate = createAction(TemplateActions.AddTemplate, props<{ template: Template }>());
export const AddClassroomFilter = createAction(TemplateActions.AddClassroomFilter, props<{ classroomFilter: ClassroomCourseFilter }>());
export const ResetClassroomFilter = createAction(TemplateActions.ResetClassroomFilter);
export const AddClassroomCourses = createAction(
  TemplateActions.AddClassroomCourses,
  props<{ classrooms: ClassroomCourse[] }>()
);
export const RemoveClassroomCourses = createAction(TemplateActions.RemoveClassroomCourses);

export const RequestClassroomCourse = createAction(TemplateActions.RequestClassroomCourse,props<{ courseRequest: CourseRequest }>());
export const AddError = createAction(TemplateActions.AddError, props<{ error: any }>());
